import { render, staticRenderFns } from "./companyForm.vue?vue&type=template&id=33a700c1&scoped=true&"
import script from "./companyForm.vue?vue&type=script&lang=js&"
export * from "./companyForm.vue?vue&type=script&lang=js&"
import style0 from "./companyForm.vue?vue&type=style&index=0&id=33a700c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a700c1",
  null
  
)

export default component.exports